import backofficeService from '../../api/backoffice'
// let paymentPosted = new Event('invoiceCreated')


export default {
  /**
   * Get list of products
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to products
   */
  getAll(params) {
    return backofficeService.Api().get('advancePayment', {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  getSummary(customerId) {
    return backofficeService.Api().get(`advancePayment/summary/${customerId}`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  applyToInvoice(data) {
    return backofficeService.Api().post('advancePayment/apply-invoice', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  applyToInvoices(data) {
    return backofficeService.Api().post('advancePayment/apply-invoices', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  /**
   * Get specific product
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to product
   */
  getById(id, params = {}) {
    return backofficeService.Api().get(`advancePayment/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  create(data) {
    return backofficeService.Api().post('advancePayment', data)
      .then(response => {
        // document.dispatchEvent(paymentPosted)
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
  collect(data) {
    return backofficeService.Api().post('advancePayment/collect', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Update specific product
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`advancePayment/${id}`, data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Delete product
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`advancePayment/${id}`, {
        params
      })
      .then(response => {
        // document.dispatchEvent(paymentPosted)
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  attachInvoice(data) {
    return backofficeService.Api().post('advancePayment/attachInvoice', data)
      .then(response => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  getDetailById(id, params = {}) {
    return backofficeService.Api().get(`/advancePaymentDetail/advancePayment/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },


}
